import { Component, OnInit, ViewChild, Input, OnChanges, SimpleChanges, Output, EventEmitter } from '@angular/core';

import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { SolarService } from '../../services/solarservice.service';
import { MessageError } from 'base-models';
import { AlertType } from 'base-models';
import { Supervision, Flight, SupervisionStatusEnum } from 'solar-bo';
import { AppInjector } from 'base-models';
import { ErrorcontrolService } from 'basecomponents';
import { FlightBaseComponent } from '../flight-helper.component';
import { SortHelper } from 'shtools';


@Component({
  selector: 'app-flight-files',
  templateUrl: './flight-files.component.html',
  styleUrls: ['./flight-files.component.scss']
})
export class FlightFilesComponent extends FlightBaseComponent implements OnInit, OnChanges {

  @Input() flight: Flight;
  @Input() supervision: Supervision;
  @ViewChild(MatSort, { static: false }) sort: MatSort;
  @ViewChild(MatPaginator, { static: false }) paginator: MatPaginator;


  displayedColumns = ['imageshower', 'name', 'filetype', 'filesize','date_taken', 'creation_date', 'status', 'actions'];
  dataSource = new MatTableDataSource<any>(this.listOriginal);
  filteredList: any;
  //public dialog: MatDialog;
  public solarService: SolarService;

  public constructor() {
    super();
    const injector = AppInjector.getInjector();
    this.solarService = injector.get(SolarService);
  }

  ngOnInit() {
    console.log("FlightListComponent ngOnInit", this.flight);
    this.getList();
  }

  ngOnChanges(changes: SimpleChanges) {
  }

  refresh() {
    this.getList();
  }

  getList(): void {
    if (!this.flight) {
      return;
    }
    this.listerrmessage = "";
    this.loading = true;

    this.solarService.flightGetFilesById(this.flight.id)
      .subscribe(
        reslist => this.getListhandleresult(reslist)
        , err => this.getListhandleError(err)
      );
  }

  getListhandleresult(newlist: any[]) {
    console.log('getListhandleresult', newlist);
    this.listerrmessage = '';
    this.loading = false;
    newlist = SortHelper.sortMultiple(newlist, ["info.creation_date"], ["asc"])

    for (let elem of newlist) {
      elem.id_site = this.supervision.site.id;
      elem.id_supervision = this.supervision.id;
    }
    this.listOriginal = newlist;
    this.configsource();
    this.alertmessage = null;
  }
  getListhandleError<T>(err: any) {
    console.log("getListhandleError");
    this.loading = false;
    this.alertmessage = ErrorcontrolService.basichandleError("", err);
  }

  showmessage(message: string) {
    this.alertmessage = new MessageError(AlertType.Success, message);
  }

  configsource() {
    this.dataSource = new MatTableDataSource<any>(this.listOriginal);
    this.dataSource.sort = this.sort;
    this.dataSource.paginator = this.paginator;
  }

  uiisdeletable(element: any) {
    let st=this.supervision.info.status;
    if (st==SupervisionStatusEnum.LOCKED || st==SupervisionStatusEnum.VALIDATED )
    {
      return false;
    }
    return true;
  }

  itemSelected(item: Flight) {
    this.selectedItemEvent.next(item);
  }

  ui_getstatus(row) {
    let ret = "";
    try {
      return row.info.status;
/*       switch (row.info.status) {
        case 0:
          ret = "Uploaded";
          break;
        case 1:
          ret = "Processing";
          break;
        case 2:
          ret = "Processed";
          break;
      } */

    }
    catch (err) {
      ret = "unknown";
      //console.log(err);

    }
    return ret;

  }


}

